export enum CarrierCrmLeadStatus {
  New = 'New',
  Qualified = 'Qualified',
  Hauling = 'Hauling',
  Rejected = 'Rejected',
}
